/* THIS FILE IS GENERATED. DO NOT EDIT */
// @ts-ignore
            
import * as Types from '@generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ValidateInvitationQueryVariables = Types.Exact<{
  token: Types.Scalars['String']['input'];
}>;


export type ValidateInvitationQuery = { __typename?: 'Root', invitation: { __typename?: 'Invitation', valid: boolean, isNewAdmin: boolean } };


export const ValidateInvitationDocument = gql`
    query ValidateInvitation($token: String!) {
  invitation(token: $token) {
    valid
    isNewAdmin
  }
}
    `;

/**
 * __useValidateInvitationQuery__
 *
 * To run a query within a React component, call `useValidateInvitationQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateInvitationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateInvitationQuery({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useValidateInvitationQuery(baseOptions: Apollo.QueryHookOptions<ValidateInvitationQuery, ValidateInvitationQueryVariables> & ({ variables: ValidateInvitationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ValidateInvitationQuery, ValidateInvitationQueryVariables>(ValidateInvitationDocument, options);
      }
export function useValidateInvitationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ValidateInvitationQuery, ValidateInvitationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ValidateInvitationQuery, ValidateInvitationQueryVariables>(ValidateInvitationDocument, options);
        }
export function useValidateInvitationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ValidateInvitationQuery, ValidateInvitationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ValidateInvitationQuery, ValidateInvitationQueryVariables>(ValidateInvitationDocument, options);
        }
export type ValidateInvitationQueryHookResult = ReturnType<typeof useValidateInvitationQuery>;
export type ValidateInvitationLazyQueryHookResult = ReturnType<typeof useValidateInvitationLazyQuery>;
export type ValidateInvitationSuspenseQueryHookResult = ReturnType<typeof useValidateInvitationSuspenseQuery>;
export type ValidateInvitationQueryResult = Apollo.QueryResult<ValidateInvitationQuery, ValidateInvitationQueryVariables>;